module.exports = __webpack_public_path__ + "static/media/Stageplan2.e2ce77ef.pdf";